// extracted by mini-css-extract-plugin
module.exports = {"customerCard":"customersimplified_customerCard__2Xjd_","selectIcon":"customersimplified_selectIcon__3bVa2","overlay":"customersimplified_overlay__1dntM"};